// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"112":"build-glob","220":"build-doc","839":"build-map"}[chunkId] + "." + {"112":"ef5e0824","220":"a42070be","839":"a758bea2"}[chunkId] + ".css";
};